import React from "react";
import "./MessageBubble.css"; // Import the custom CSS file
import agentSvg from "./../../agent.svg";
import { RotateCcw } from "lucide-react";
const MessageBubble = ({ msg, role, data, isError, onRetry }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <div className={`message-container ${role}`}>
      <div className="avatar">
        {role == "assistant" ? (
          <img src={agentSvg} alt="Avatar" className="avatar-img" />
        ) : (
          <div className="avatar-img">
            <p className="user-initials">
              {user.result[0].user.firstName.charAt(0).toUpperCase()}
              {user.result[0].user.lastName.charAt(0).toUpperCase()}
            </p>
          </div>
        )}
      </div>
      <div className="message-bubble">
        {msg}
        <div>{data}</div>
      </div>
      {isError && (
        <div className="retry" onClick={onRetry}>
          <RotateCcw />
        </div>
      )}
    </div>
  );
};

export default MessageBubble;
